<sh-main-nav-single-item
  [item]="items.plansItem"
  (closeMenu)="onCloseMenu()"></sh-main-nav-single-item>
<a
  href="https://docs.besmarthead.com/getting-started/introduction"
  target="_blank"
  >{{ 'header.resources' | transloco }}</a
>
<sh-main-nav-single-item
  [item]="items.mediaItem"
  (closeMenu)="onCloseMenu()"></sh-main-nav-single-item>
<div
  class="nested-item"
  (click)="openAboutUs()">
  <a
    data-cy="main-nav-our-products"
    [attr.title]="'header.who-we-are' | transloco">
    {{ 'header.who-we-are' | transloco }}
  </a>
  <ui-icon
    class="chevron"
    key="chevron-right"></ui-icon>
</div>

<ng-container *ngIf="(nav.hasProfile$ | async) === false">
  <sh-main-nav-request-demo (closeMenu)="onCloseMenu()"></sh-main-nav-request-demo>
</ng-container>

<div
  class="nested-item-content"
  *ngIf="(aboutUsOpen$ | async) === true">
  <div
    class="nested-item-content-header"
    (click)="closeAboutUs()">
    <ui-icon
      class="chevron"
      key="chevron-left"></ui-icon>
    <a>{{ 'header.who-we-are' | transloco }}</a>
  </div>

  <div class="nested-item-content-list">
    <sh-main-nav-single-item
      [item]="items.ourPurposeItem"
      (closeMenu)="onCloseMenu()"></sh-main-nav-single-item>
    <sh-main-nav-single-item
      [item]="items.aboutUsItem"
      (closeMenu)="onCloseMenu()"></sh-main-nav-single-item>
    <sh-main-nav-single-item
      [item]="becomePartner"
      (closeMenu)="onCloseMenu()"></sh-main-nav-single-item>
    <sh-main-nav-single-item
      [item]="items.advisoryBoardItem"
      (closeMenu)="onCloseMenu()"></sh-main-nav-single-item>
    <sh-main-nav-single-item
      [item]="items.contactItem"
      (closeMenu)="onCloseMenu()"></sh-main-nav-single-item>
  </div>
</div>
